import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  supportDataOrEmptyObjectSelector,
  previousSupportDataOrEmptyObjectSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { DOWN_PAYMENT, MORTGAGE_DETAILS, MORTGAGE } from '../../../Summaries/SummaryConstants';
import dictionarySelector from '../../../Summaries/SummaryDictionarySelector';
import { HOME_PURCHASE_GOAL_GRAPH_NODE } from '../../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';

export const nullableHasPlanToGetMortgageSelector = (state, props) =>
  get(
    supportDataOrEmptyObjectSelector(state, props),
    `${HOME_PURCHASE_GOAL_GRAPH_NODE}.HasPlanToGetMortgage`,
    null,
  );

export const nullableHadPlanToGetMortgageSelector = (state, props) =>
  get(
    previousSupportDataOrEmptyObjectSelector(state, props),
    `${HOME_PURCHASE_GOAL_GRAPH_NODE}.HasPlanToGetMortgage`,
    null,
  );

export const alreadyHadMortgageSelector = (state, props) =>
  get(
    supportDataOrEmptyObjectSelector(state, props),
    `${HOME_PURCHASE_GOAL_GRAPH_NODE}.AlreadyHadMortgage`,
    null,
  );

const nextIteratorsSelector = createSelector(
  nullableHasPlanToGetMortgageSelector,
  nullableHadPlanToGetMortgageSelector,
  dictionarySelector,
  (planToGetMortgage, hadPlanToGetMortgage, dictionary) => {
    if (hadPlanToGetMortgage === planToGetMortgage) {
      return [];
    }
    if (planToGetMortgage === true) {
      return [DOWN_PAYMENT, MORTGAGE_DETAILS]
        .map(dependencies => dictionary[dependencies].iterator);
    }
    return [];
  },
);

export const previousIteratorsSelector = createSelector(
  dictionarySelector,
  (dictionary) => {
    if (dictionary[MORTGAGE]) {
      return [dictionary[MORTGAGE].iterator];
    }
    return [];
  },
);

export default nextIteratorsSelector;
